var _rect, _rect2, _path, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _circle4, _path3, _path4, _path5, _path6, _path7, _path8, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkedCars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 578,
    viewBox: "0 0 682 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.512,
    y: 379.213,
    width: 74.112,
    height: 57.028,
    rx: 28.514,
    transform: "rotate(-30 28.512 379.213)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 489.144,
    y: 47.425,
    width: 57.091,
    height: 57.091,
    rx: 28.545,
    transform: "rotate(-30 489.144 47.425)",
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.268 254.619c-13.654 7.882-18.331 25.341-10.449 38.994 7.883 13.653 25.341 18.331 38.994 10.448l43.033-24.845-.28.164 74.186-42.831c13.653-7.883 31.111-3.205 38.994 10.448 7.821 13.547 3.277 30.84-10.132 38.808l185.249-106.953a29.221 29.221 0 001.709-1.067c-13.357 6.52-29.674 1.675-37.219-11.393-7.544-13.067-3.583-29.619 8.74-37.927-.598.292-1.191.607-1.776.945l-1.691.977c13.625-7.893 18.287-25.332 10.412-38.973-7.883-13.653-25.341-18.331-38.994-10.448L130.268 254.619zm433.014 79.617c13.653-7.883 18.331-25.341 10.449-38.994-7.883-13.653-25.341-18.331-38.994-10.448l-168.618 97.351c-13.653 7.883-18.331 25.341-10.448 38.994 7.883 13.653 25.341 18.331 38.994 10.448l168.617-97.351zM437.71 274.891l-1.281.739c.192-.105.385-.207.579-.307-12.818 8.161-17.044 25.054-9.372 38.342 7.649 13.249 24.316 18.046 37.772 11.115-.352.224-.711.442-1.076.652l-138.095 79.73c13.34-7.992 17.847-25.239 10.043-38.756-7.882-13.653-25.34-18.331-38.993-10.448l-89.555 51.704c-13.577 7.489-30.711 2.761-38.499-10.728-7.883-13.653-3.205-31.111 10.448-38.993l351.661-203.032c13.653-7.883 31.112-3.205 38.994 10.448 7.883 13.653 3.205 31.112-10.448 38.994l-23.852 13.771c-.126.07-.252.142-.377.214l-97.575 56.335c-.125.072-.25.146-.374.22z",
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 616.804,
    cy: 405.324,
    r: 14.811,
    stroke: "#E6E6E6",
    strokeWidth: 7.129
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.62,
    cy: 126.454,
    r: 11.009,
    stroke: "#E6E6E6",
    strokeWidth: 7.129
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.559,
    cy: 501.775,
    r: 16.884,
    stroke: "#E6E6E6",
    strokeWidth: 7.129
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 404.664,
    y: 14.575,
    width: 35.484,
    height: 6.336,
    rx: 3.168,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 425.568,
    width: 35.484,
    height: 6.336,
    rx: 3.168,
    transform: "rotate(90 425.568 0)",
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 521.059,
    y: 497.087,
    width: 26.613,
    height: 6.336,
    rx: 3.168,
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 537.535,
    y: 487.269,
    width: 26.613,
    height: 6.336,
    rx: 3.168,
    transform: "rotate(90 537.535 487.269)",
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.502,
    y: 312.565,
    width: 26.613,
    height: 6.336,
    rx: 3.168,
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51.978,
    y: 302.747,
    width: 26.613,
    height: 6.336,
    rx: 3.168,
    transform: "rotate(90 51.978 302.747)",
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111.88,
    y: 156.633,
    width: 104.422,
    height: 123.068,
    rx: 22.376,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 223.76,
    y: 305.806,
    width: 309.536,
    height: 96.963,
    rx: 33.875,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.61 230.097c4.012-14.748 17.403-24.983 32.687-24.983h148.461c15.284 0 28.675 10.235 32.687 24.983l20.595 75.709H251.015l20.595-75.709z",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.699,
    cy: 354.288,
    r: 18.647,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.865 402.769h48.482v33.409c0 8.325-6.749 15.073-15.073 15.073h-18.336c-8.325 0-15.073-6.748-15.073-15.073v-33.409z",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.708 402.769h48.481v33.409c0 8.325-6.748 15.073-15.072 15.073h-18.336c-8.325 0-15.073-6.748-15.073-15.073v-33.409z",
    fill: "#ECECEC",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.241 227.49h212.573M96.962 451.251h451.25M164.09 283.431v167.82",
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.09 160.362h29.835c10.298 0 18.646 8.349 18.646 18.647v78.316c0 10.299-8.348 18.647-18.646 18.647H164.09v-115.61z",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.502 226.135h6.267c10.384 0 18.802-7.975 18.802-17.813 0-9.837-8.418-17.812-18.802-17.812h-9.401v56.406",
    stroke: "#AFAFAF",
    strokeWidth: 7.459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.663 309.536h123.068c16.478 0 29.835 13.358 29.835 29.835v29.835c0 16.477-13.357 29.834-29.835 29.834H376.663v-89.504zM376.663 231.22h105.195l19.314 70.857H376.663V231.22zM376.663 208.844h76.351a30.477 30.477 0 0126.206 14.917H376.663v-14.917z",
    fill: "#ECECEC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.355,
    cy: 354.288,
    r: 18.647,
    stroke: "#AFAFAF",
    strokeWidth: 7.459
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkedCars);
export default __webpack_public_path__ + "static/media/parked-cars.5f46c6a7.svg";
export { ForwardRef as ReactComponent };